
















// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";

// Constants
import Assets from "@/constants/assets.ts";
import RouteNames from "@/constants/route-names";

// Models
import { TypeOfProduct } from "@/manager/product/models/product.model";

export enum SubtitleColor {
  Primary = "card__subtitle--primary",
  Secondary = "card__subtitle--secondary",
}

export interface ProductCategory {
  id?: string;
  image?: string;
  type?: string | number;
  title: string;
  subtitle?: {
    text: string;
    color: SubtitleColor;
  };
}


@Component
export default class ProductCategoryCard extends Vue {
  @Prop() private content!: ProductCategory;


  private assets = Assets;


  get hasImage() {
    return this.content.image !== undefined;
  }

  get hasSubtitle() {
    return this.content.subtitle !== undefined;
  }

  get subtitleColor() {
    let color = SubtitleColor.Secondary;

    if (this.content.subtitle && this.content.subtitle.color) {
      color = this.content.subtitle.color;
    }

    return color;
  }

  get backgroundImg() {
    return {
      "background-image": `url("${this.assets.iconSemiCircle}")`,
      "background-repeat": "no-repeat",
      "background-position": "center bottom"
    };
  }
}

